import classNames from 'classnames';
import DotsLoading from '../dotsLoading';
import styles from './customButton.module.scss';
interface ICustomButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  disabled?: boolean;
  outLet?: boolean;
  isLoading?: boolean;
  noBorder?: boolean;
}
const CustomButton = ({
  title,
  disabled,
  outLet,
  isLoading,
  noBorder,
  ...props
}: ICustomButtonProps) => {
  return (
    <>
      <button
        {...props}
        className={classNames(
          noBorder
            ? styles['btn-custom-no-border']
            : outLet
            ? styles['btn-custom-outlet']
            : styles['btn-custom'],
          props.className,
        )}
        disabled={disabled || isLoading}
      >
        {isLoading ? <DotsLoading /> : title ? title : props.children}
      </button>
    </>
  );
};

export default CustomButton;
